<template>
    <div class="confirmation-box">
        <iq-card>
         <template v-slot:headerTitle>
               <h4 class="card-title">Order Confirmation</h4>
         </template>
      <template v-slot:default >
      <div v-if="order && order.name">
         <div>
            <div class="card p-2 background-container">
               <div class="invoice">
                  <span class="font-weight-bold d-block mt-4">Hello, {{ order.name }}.</span>
                  <span>You order has been received!</span>
                  <div class="payment border-top mt-3 mb-3 border-bottom table-responsive">
                     <table class="table table-borderless">
                        <tbody>
                           <tr>
                              <td>
                                 <div class="py-2">
                                    <span class="d-block muted-text">Order Date</span>
                                    <span>{{ formatDate(order.date )}}</span>
                                 </div>
                              </td>
                              <td>
                                 <div class="py-2">
                                    <span class="d-block muted-text">Order No</span>
                                    <span>{{ sessionId }}</span>
                                 </div>
                              </td>
                              <td>
                                 <div class="py-2 text-right">
                                    <span class="d-block muted-text">Payment</span>
                                    <span><img src="https://img.icons8.com/color/48/000000/mastercard.png" width="20" /></span>
                                 </div>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                     <table class="table table-borderless">
                        <tbody>
                           <tr>
                              <td>
                                 <div class="py-2">
                                    <span class="d-block muted-text">Shipping address</span>
                                    <span>None</span>
                                 </div>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <div class="product border-bottom table-responsive">
                     <table class="table table-borderless">
                        <tbody>
                           <tr v-for="product in order.products" :key="product.priceId">
                              <td width="20%">
                                 <img src="../../assets/images/workout.png" v-if="product.name.includes('session')" width="90">
                                 <img src="../../assets/images/tokens.png" v-if="product.name.includes('coin')" width="90">
                                 <img class="rounded " v-if="product.name === 'Glove'" src="../../assets/images/glove.png" width="90">
                                 <img class="rounded" v-if="product.name === 'Knee Sleeve'" src="../../assets/images/knee_sleeve.png" width="90">
                                 <img class="rounded" v-if="product.name === 'Neat'" src="../../assets/images/neat.png" width="90">
                                 <img class="rounded" v-if="product.name === 'Pants'" src="../../assets/images/knee_sleeve.png" width="90">
                                 <img class="rounded" v-if="product.name === 'Band'" src="../../assets/images/band.jpg" width="90">
                              </td>
                              <td width="60%">
                                 <span class="font-weight-bold">{{ product.name }}</span>
                                 <div class="product-qty">
                                    <span class="d-block">Quantity: {{ product.quantity }}</span>
                                 </div>
                              </td>
                              <td width="20%">
                                 <div class="text-right">
                                    <span class="font-weight-bold">$ {{ formatPrice(product.quantity * product.unit_price) }}</span>
                                 </div>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <div class="row d-flex justify-content-end">
                     <div class="col-md-5">
                        <table class="table table-borderless">
                           <tbody class="totals">
                              <tr>
                                 <td>
                                    <div class="text-left">
                                       <span class="muted-text">Subtotal</span>
                                    </div>
                                 </td>
                                 <td>
                                    <div class="text-right">
                                       <span>$ {{  formatPrice(subtotal) }}</span>
                                    </div>
                                 </td>
                              </tr>
                              <!-- <tr>
                                 <td>
                                    <div class="text-left">
                                       <span class="muted-text">Shipping Fee</span>
                                    </div>
                                 </td>
                                 <td>
                                    <div class="text-right">
                                       <span>$ 0</span>
                                    </div>
                                 </td>
                              </tr> -->
                              <tr>
                                 <td>
                                    <div class="text-left">
                                       <span class="muted-text">PST (7%)</span>
                                    </div>
                                 </td>
                                 <td>
                                    <div class="text-right">
                                       <span>$ {{ Number(Number(formatPrice(subtotal)) * 0.07).toFixed(2) }}</span>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td>
                                    <div class="text-left">
                                       <span class="muted-text">GST (5%)</span>
                                    </div>
                                 </td>
                                 <td>
                                    <div class="text-right">
                                       <span>$ {{ Number(Number(formatPrice(subtotal)) * 0.05).toFixed(2) }}</span>
                                    </div>
                                 </td>
                              </tr>
                              <!-- <tr>
                                 <td>
                                    <div class="text-left">
                                       <span class="muted-text">Discount</span>
                                    </div>
                                 </td>
                                 <td>
                                    <div class="text-right">
                                       <span class="text-success">$168.50</span>
                                    </div>
                                 </td>
                              </tr> -->
                              <tr class="border-top border-bottom">
                                 <td>
                                    <div class="text-left">
                                       <span class="font-weight-bold">Total</span>
                                    </div>
                                 </td>
                                 <td>
                                    <div class="text-right">
                                       <span class="font-weight-bold">$ {{ formatPrice(order.total) }}</span>
                                    </div>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
                  <!-- <p>We will be sending shipping confirmation email when the item shipped successfully!</p> -->
                  <p class="font-weight-bold mb-0">Thanks for shopping with us!</p>
                  <span>Texavie Team</span>
               </div>
               <!-- <div class="d-flex justify-content-between footer p-3">
                  <span>Need Help? visit our <a href="#"> help center</a></span>
                  <span>12 June, 2020</span>
               </div> -->
            </div>
         </div>
      </div>
      <div v-else>
         <el-skeleton :rows="5" animated />
      </div>
   </template>
</iq-card>
    </div>

</template>

<script>
import { xray } from '../../config/pluginInit'
import { useStore } from 'vuex'
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import getDocument from '../../services/getDocument'
const body = document.getElementsByTagName('body')

export default {
  setup () {
    const store = useStore()
    const emptyCart = () => store.dispatch('shoppingCart/emptyCart')

    const route = useRoute()
    const sessionId = ref(null)
    const { document: order } = getDocument('orders', route.params.sessionId)
    onMounted(async () => {
      sessionId.value = route.params.sessionId
      if (route.name === 'patient.orderSuccess') {
        emptyCart()
      }
    })

    const formatDate = (timestamp) => {
      const date = timestamp.toDate()
      const options = { month: 'long', day: 'numeric', year: 'numeric' }
      return date.toLocaleDateString('en-US', options)
    }

    const formatPrice = (price) => {
      return (price / 100).toFixed(2)
    }

    const subtotal = computed(() => {
      return order.value.products.reduce((total, product) => {
        return total + product.unit_price * product.quantity
      }, 0)
    })
    return {
      sessionId,
      order,
      formatDate,
      formatPrice,
      subtotal
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

<style scoped>
    .confirmation-box {
        padding: 0 20px;
    }

    .rounded {
      aspect-ratio: 1 / 1;
      object-fit: cover;
    }
</style>
